export enum Configs {
   API_URL = 'https://api.betshop.pro/api/v2',
   SupportEmail = 'support@trx5.ltd',
}